/* eslint-disable @typescript-eslint/no-explicit-any */
export type AssetLocale = { country: string; lang: string };

function trimSlashes(s: string) {
  return s.replace(/^\/+|\/+$/g, '');
}

export function getEfBase() {
  return trimSlashes(import.meta.env.VITE_ASSETS_BASE);
}

export function buildEfJsonModelUrl(path: string, { country, lang }: AssetLocale) {
  const base = getEfBase();
  const assetName = trimSlashes(path);
  return `/${base}/${country}/${lang}/${assetName}/master.model.json`;
}

export function buildEfHtmlModelUrl(path: string, { country, lang }: AssetLocale) {
  const base = getEfBase();
  const assetName = trimSlashes(path);
  return `/${base}/${country}/${lang}/${assetName}/master.html`;
}

export type BannerVM = {
  title?: string;
  pretitle?: string;
  description?: string;
  imagePath?: string;
  linkUrl?: string;
};

export function selectBanner(json: unknown): BannerVM {
  const root: any = (json as any)?.[':items']?.root;
  const teaser: any = root?.[':items']?.teaser ?? {};

  const pretitle = normalizeText(teaser.pretitle);
  const title = normalizeText(teaser.title);
  const description = normalizeText(teaser.description);
  return {
    pretitle,
    title,
    description,
    imagePath: teaser.imagePath,
    linkUrl: teaser.link?.url,
  };
}

function extractTextFromHtml(html: string): string {
  const temp = document.createElement('div');
  temp.innerHTML = html;
  return temp.textContent || temp.innerText || '';
}

function isHtmlString(str: any): boolean {
  return typeof str === 'string' && /<[^>]+>/.test(str);
}

export function normalizeText(raw?: any): string | undefined {
  if (typeof raw !== 'string') return undefined;
  return isHtmlString(raw) ? extractTextFromHtml(raw) : raw;
}

export function resolveAEMAssetUrl(path?: string): string {
  if (!path) return '';
  const trimmed = path.startsWith('/') ? path : `/${path}`;
  const base = import.meta.env.VITE_ASSETS_HOST;
  return `${base}${trimmed}`;
}
